import { useState } from "react";

import AgentGroupList from "./components/AgentGroupList";
import CreateAgentGroup from "./components/CreateAgentGroup";

import PlusIcon from "../../../../Components/Icon-SVG/PlusIcon";

import "./styles.scss";

const AgentGroups = ({ selectedHost }) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div className="agent-group">
      <div className="agent-group__header">
        <div>
          <h1>Agent Groups</h1>
          <p>Organize agents into groups for config assignment</p>
        </div>
        <button
          type="button"
          className="save-button primary-button"
          onClick={() => setShowPopup(true)}>
          <PlusIcon color="var(--dashboard-value-color)" width={16} height={16} /> Create Group
        </button>
      </div>
      <AgentGroupList selectedHost={selectedHost} />
      <CreateAgentGroup
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        selectedHost={selectedHost}
      />
    </div>
  );
};

export default AgentGroups;
